import getChannelsFromSubscriptionQuery from './getChannelsFromSubscriptionQuery';
import handleAMBSubscription from './handleAMBSubscription';

/**
 * Sets up handlers for each gql amb subscription
 *
 * @private
 * @param action
 * @param options
 * @param resultData
 * @param actionMetaData
 * @param dispatch
 * @param registryId
 * @param ambClient
 * @param ambChannelRegistry
 */
export default function handleGraphQLSubscription(
	action,
	options,
	resultData,
	actionMetaData,
	dispatch,
	registryId,
	ambClient,
	ambChannelRegistry
) {
	const {payload} = action;
	const {subscribe: shouldSubscribe = false} = payload;
	const channels = getChannelsFromSubscriptionQuery(resultData);
	const {length: channelsLength} = channels;
	for (let i = 0; i < channelsLength; i++) {
		handleAMBSubscription({
			shouldSubscribe,
			registryId,
			...channels[i],
			ambClient,
			ambChannelRegistry,
			options,
			actionMetaData,
			dispatch
		});
	}
}
